'use strict';

import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { IBulkOperationConfigInterface, IBulkOperationDropdownItem, IBulkOperationItem } from '../interfaces/bulk-operation.interface';
import { BulkOperationService } from '../services/bulk-operation.service';

@Component({
  selector: 'gen-bulk-operation',
  templateUrl: './bulk-operation.component.html',
  styleUrls: ['./bulk-operation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BulkOperationComponent implements OnInit {

  @Input() bulkOperationConfig: IBulkOperationConfigInterface;
  @Input() disabled: boolean = true;
  public bulkOperationOptions: Array<IBulkOperationDropdownItem> = [];

  constructor(private _bulkOperationService: BulkOperationService) {
  }

  ngOnInit(): void {
    this._bulkOperationService.pollingInterval = this.bulkOperationConfig.pollingInterval;
    this.buildDropdown();
  }

  buildDropdown() {
    if (!this.bulkOperationConfig || !this.bulkOperationConfig.operations) {
      console.warn('BulkOperationComponent->buildDropdown: missing configuration');
      return;
    }
    this.bulkOperationConfig.operations.forEach((operation: IBulkOperationItem) => {
      this.bulkOperationOptions.push({
        label: operation.label,
        command: () => this._bulkOperationService.executeBulkOperation(operation)
      });
    });
  }

}
